import React from 'react';
import { Result, Button } from 'antd';
import { BtnLink } from './Buttons';
import { logOut } from "../actions";
import { connect } from 'react-redux';
export function ErrorScreen(props) {

  return <Result
    status="500"
    title="500"
    subTitle="Desculpe, tivemos uma falha no processamento..."
    extra={<div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
      <Button style={{ fontSize: 20 }} type="link" onClick={() => document.location.reload(true)}>Tentar novamente</Button>
      <BtnLink txtConfirm="Ao sair a sessão será encerrada." showConfirm style={{ fontSize: 20, marginTop: 15 }} type="link" onClick={() => {
        // localStorage.clear(); 
        props.logOut();
        document.location.reload(true);
      }}>Sair</BtnLink>
    </div>}
  />;
}

export default connect(null, { logOut })(ErrorScreen);